export default __webpack_public_path__ + "static/media/accordion-toggle-icon.0c771974.svg";